import { Gltf } from '../gltf';
import { readAnimationStateExtras } from '../gltf/AnimationStateExtras';
import { readAnimationEventsExtras } from '../gltf/AnimationEventsExtras';
import { RenderObject } from '../object/RenderObject';
import { AnimationState } from './AnimationState';
import { EntityAnimationState } from './EntityAnimationState';

export function createAnimationState(object: RenderObject, json: Gltf): AnimationState {
  const extras = readAnimationStateExtras(json);
  const authoredEvents = readAnimationEventsExtras(json);

  let state: AnimationState;
  if (extras && extras.type === 'Entity') {
    state = new EntityAnimationState(object, extras.stateMapping);
  } else {
    // Backward compatibility: build identity mapping from glTF animation names.
    state = new AnimationState(object);
    const animations = json.animations ?? [];
    const allowed: Record<string, { repeat: string; speed: number }> = {};
    for (let i = 0; i < animations.length; i++) {
      const id = animations[i].name || `Anim${i}`;
      allowed[id] = { repeat: 'always', speed: 1.0 };
    }
    state.allowedStates = allowed;
  }

  // Wire authored per-clip events (if any) onto every animation-state shape.
  // The hardcoded per-state events in `ENTITY_STATE_BEHAVIORS` remain as a
  // fallback for clips the author hasn't touched yet — `dispatchEvents`
  // checks `clipEvents[clipId]` first.
  if (authoredEvents) {
    state.clipEvents = authoredEvents;
  }

  return state;
}
